import { Dialog as KendoDialog } from "@progress/kendo-react-dialogs";
export const Dialog = ({title, onClose, width = 1000, children, ...otherProps}) => {

    return (
        <KendoDialog
            title={title}
            onClose={onClose}
            width={width}
            {...otherProps}
        >
            {children}
        </KendoDialog>
    );
};